import React, { useEffect, useState } from "react";
import { Container, Button, Form, InputGroup } from "react-bootstrap";
import { ValidationMessage } from "../../utils/constants/validationMessage";
import { useForm, Controller } from "react-hook-form";
import { regex } from "../../utils/constants/regexVariables";
import { matchesNewPassword, whiteSpaceCheck } from "../../helper/helper";
import { ErrorMessage } from "@hookform/error-message";
import useToastContext from "../../hooks/useToastContext";
import { resetPasswordApi } from "../../hooks/ApisContainer/Auth";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Loader } from "lucide-react";

const ResetPassword = () => {
  const notification = useToastContext();
  const navigate = useNavigate();
  const { id } = useParams();
  const Token = localStorage.getItem("token");
  const userType = localStorage.getItem("user-type");

  // React Hook Form
  const {
    control,
    watch,
    setValue,
    formState: { errors },
    handleSubmit,
  } = useForm();

  // Loader and visibility state
  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    if (Token) {
      if (userType == "member") {
        navigate("/member-info");
      } else {
        navigate("/dashboard");
      }
    }
  }, [Token]);

  const onSubmit = (data) => {
    const requestPayload = { password: data.newPassword || "" };

    resetPasswordApi(requestPayload, id, notification, (loading, error) => {
      setLoader(loading);
      if (!error) {
        navigate("/login");
      }
    });
  };

  return (
    <section className="login-sec for-mobile">
      <Container>
        <Form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
          <div className="wrapper">
            <div className="common-heading text-center mb-4">
              <h2>Reset Password?</h2>
            </div>

            {/* New Password */}
            <Form.Group className="mb-4">
              <InputGroup>
                <Controller
                  name="newPassword"
                  control={control}
                  rules={{
                    required: ValidationMessage.PASSWORD_REQUIRED,
                    pattern: {
                      value: regex.regPassword,
                      message: ValidationMessage.PASSWORD_VALID,
                    },
                    validate: (value) => whiteSpaceCheck(value),
                  }}
                  render={({ field }) => (
                    <Form.Control
                      {...field}
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter new password"
                    />
                  )}
                />
                <Button
                  variant="outline-secondary"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <i className="bi bi-eye"></i>
                  ) : (
                    <i className="bi bi-eye-slash"></i>
                  )}
                </Button>
              </InputGroup>
              <ErrorMessage
                errors={errors}
                name="newPassword"
                render={({ message }) => (
                  <p className="error-message text-start py-2 px-1 text-danger">
                    {message}
                  </p>
                )}
              />
            </Form.Group>

            {/* Confirm Password */}
            <Form.Group className="mb-4">
              <InputGroup>
                <Controller
                  name="confirmNewPassword"
                  control={control}
                  rules={{
                    required: ValidationMessage.CONFIRM_NEW_PASSWORD_VALID,
                    validate: (value) =>
                      matchesNewPassword(
                        watch("newPassword"),
                        value,
                        ValidationMessage.CONFIRM_PASSWORD_VALID
                      ),
                  }}
                  render={({ field }) => (
                    <Form.Control
                      {...field}
                      type={showConfirmPassword ? "text" : "password"}
                      placeholder="Enter confirm password"
                    />
                  )}
                />
                <Button
                  variant="outline-secondary"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? (
                    <i className="bi bi-eye"></i>
                  ) : (
                    <i className="bi bi-eye-slash"></i>
                  )}
                </Button>
              </InputGroup>
              <ErrorMessage
                errors={errors}
                name="confirmNewPassword"
                render={({ message }) => (
                  <p className="error-message text-start py-2 px-1 text-danger">
                    {message}
                  </p>
                )}
              />
            </Form.Group>

            {/* Submit Button */}
            <Button
              type="submit"
              className="themeht-btn btn w-100 py-2 mt-3"
              disabled={loader}
              style={loader ? { cursor: "not-allowed" } : { cursor: "pointer" }}
            >
              <span className="d-flex fs-6 justify-content-center align-items-center">
                Submit{" "}
                {loader && (
                  <Loader
                    style={{
                      marginLeft: "20px",
                    }}
                    className="loader"
                  />
                )}
              </span>
            </Button>

            {/* Link to Login */}
            <div className="dont-have-account pt-4 text-center">
              <h4>
                Return to? <a href="/login">Login</a>
              </h4>
            </div>
          </div>
        </Form>
      </Container>
    </section>
  );
};

export default ResetPassword;
